import { AgreementScopeDTO, FilterTypes } from 'models'

export const defaultScope: AgreementScopeDTO = {
  id: null,
  budget: null,
  name: 'Scope 1',
  filters: [
    {
      id: null,
      budget: null,
      type: FilterTypes.BRANDS,
      brands: [],
      projects: null,
      products: null,
      values: null
    },
    {
      id: null,
      budget: null,
      type: FilterTypes.PROJECTS,
      brands: null,
      projects: [],
      products: null,
      values: null
    },
    {
      id: null,
      budget: null,
      type: FilterTypes.PRODUCTS,
      brands: null,
      projects: null,
      products: [],
      values: null
    }
  ]
}

export enum ObjectValueStatus {
  ADDED = 'added',
  CHANGED = 'changed',
  REMOVED = 'removed',
  UNCHANGED = 'unchanged'
}

export interface ObjectValueDiff {
  status: ObjectValueStatus
  beforeChange: any
  afterChange: any
}

export type DiffMapDeepResult<T> = { [key in keyof T]: DiffMapResult<T[key]> }
export type DiffMapResult<T> = ObjectValueDiff | DiffMapDeepResult<T>
export interface VersionChange {
  markLetter?: string
  keyId?: string
  message: string
  valueStatus: ObjectValueStatus
  valueBeforeChange: string | number
  valueAfterChange: string | number
}
